// store/Reducers/balanceReducer.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';
import axios from 'axios';
import { api_url,initSocket } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'
// USER - Balansı gətir
// export const get_user_balance = createAsyncThunk(
//     'balance/get_user_balance',
//     async (_, { rejectWithValue, getState }) => {
//         const token = getState().auth.token;
//         const config = {
//             headers: { 'Authorization': `Bearer ${token}` }
//         };
//         try {
//             const { data } = await api.get('/user/balance', config);
//             return data;
//         } catch (error) {
//             return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
//         }
//     }
// );
export const get_user_balance = createAsyncThunk(
    'balance/get_user_balance',
    async (_, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;

        //    const config= {
        //     headers: {
        //         Authorization : `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await axios.get(`${api_url}/api/user/balance`, {withCredentials: true});
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);


// USER - Balans artırma sorğusu
// export const request_deposit = createAsyncThunk(
//     'balance/request_deposit',
//     async (formData, { rejectWithValue, getState }) => {
//         const token = getState().auth.token;
//         const config = {
//             headers: { 
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'multipart/form-data'
//             }
//         };
//         try {
//             const { data } = await api.post('/user/deposit-request', formData, config);
//             return data;
//         } catch (error) {
//             return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
//         }
//     }
// );
// export const request_deposit = createAsyncThunk(
//     'balance/request_deposit',
//     async (formData, { rejectWithValue }) => {
//         try {
//             const { data } = await api.post('/user/deposit-request', formData, {
//                 withCredentials: true,
//                 headers: { 'Content-Type': 'multipart/form-data' }
//             });
//             return data;
//         } catch (error) {
//             return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
//         }
//     }
// );
export const request_deposit = createAsyncThunk(
    'balance/request_deposit',
    async (formData, { rejectWithValue, getState }) => {
        try {
            // ✅ userInfo-dan id götür, formData-ya əlavə et
            // if (userInfo?.id) {
            //     formData.append('clientUserId', userInfo.id);
            // }

            const { data } = await api.post(`/user/deposit-request`, formData, {
                withCredentials: true,
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);
// USER - Balansdan ödəniş
// export const pay_with_balance = createAsyncThunk(
//     'balance/pay_with_balance',
//     async (orderId, { rejectWithValue, getState }) => {
//         const token = getState().auth.token;
//         const config = {
//             headers: { 'Authorization': `Bearer ${token}` }
//         };
//         try {
//             const { data } = await api.post('/user/purchase-with-balance', { orderId }, config);
//             return data;
//         } catch (error) {
//             return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
//         }
//     }
// );
export const pay_with_balance = createAsyncThunk(
    'balance/pay_with_balance',
    async (orderId, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await api.post(`/user/purchase-with-balance`, { orderId }, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);
// ADMIN - Bütün deposit sorğuları
// export const get_all_deposits_admin = createAsyncThunk(
//     'balance/get_all_deposits_admin',
//     async ({ status, page, limit }, { rejectWithValue, getState }) => {
//         const token = getState().auth.token;
//         const config = {
//             headers: { 'Authorization': `Bearer ${token}` }
//         };
//         try {
//             const { data } = await api.get(
//                 `/admin/deposits/all?status=${status || ''}&page=${page}&limit=${limit}`,
//                 config
//             );
//             return data;
//         } catch (error) {
//             return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
//         }
//     }
// );
// store/reducers/balanceReducer.js
export const get_all_deposits_admin = createAsyncThunk(
  'balance/get_all_deposits_admin',
  async ({ status, page, limit }, { rejectWithValue, getState }) => {
    // ✅ Həm auth, həm admin state-dən yoxla
    // const token = getState().admin?.token || getState().auth?.token;

    // if (!token) {
    //   return rejectWithValue({ message: 'Token tapılmadı' });
    // }

    // const config = { 
    //   headers: { Authorization: `Bearer ${token}` } 
    // };

    try {
      const { data } = await axios.get(
        `${api_url}/api/admin/deposits/all?status=${status || ''}&page=${page}&limit=${limit}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
    }
  }
);

// ADMIN - Deposit təsdiq et
export const approve_deposit = createAsyncThunk(
    'balance/approve_deposit',
    async (depositId, { rejectWithValue, getState }) => {
// const token = getState().admin?.token || getState().auth?.token;         
// const config = {
//             headers: { 'Authorization': `Bearer ${token}` }
//         };
        try {
            const { data } = await api.post(`/admin/deposits/approve`, { depositId }, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);

// ADMIN - Deposit rədd et
export const reject_deposit = createAsyncThunk(
    'balance/reject_deposit',
    async ({ depositId, reason }, { rejectWithValue, getState }) => {
    //    const token = getState().admin?.token || getState().auth?.token; 
    //     const config = {
    //         headers: { 'Authorization': `Bearer ${token}` }
    //     };
        try {
            const { data } = await api.post(`/admin/deposits/reject`, { depositId, reason }, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);
export const get_all_sellers_balance = createAsyncThunk(
    'balance/get_all_sellers_balance',
    async ({ page = 1, limit = 10, search = '' }, { rejectWithValue, getState }) => {
        // const token = getState().auth.token;
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await axios.get(
                `${api_url}/api/admin/sellers/balance?page=${page}&limit=${limit}&search=${search}`,
                { withCredentials: true }
            );
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);
export const toggle_balance_block = createAsyncThunk(
    'balance/toggle_balance_block',
    async ({ userId, block, reason }, { rejectWithValue, getState }) => {
        // const token = getState().admin?.token || getState().auth?.token;
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const { data } = await api.post(`/admin/user/toggle-balance-block`, { userId, block, reason }, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);
export const get_active_bank_infos = createAsyncThunk(
    'balance/get_active_bank_infos',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`${api_url}/api/payment/bank-infos`, { withCredentials: true });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: 'Xəta baş verdi' });
        }
    }
);
// Reducer
export const balanceReducer = createSlice({
    name: 'balance',
    initialState: {
        balance: 0,
        transactions: [],
        deposits: [],
        totalDeposits: 0,
        loader: false,
        successMessage: '',
        sellersBalance: [],
        totalSellersBalance: 0,
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        }
    },
    extraReducers: (builder) => {
        builder
            // Get balance
            .addCase(get_user_balance.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_user_balance.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.balance = payload.balance || 0;
                state.transactions = payload.transactions || [];
            })
            .addCase(get_user_balance.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Xəta baş verdi';
            })
            
            // Request deposit
            .addCase(request_deposit.pending, (state) => {
                state.loader = true;
            })
            .addCase(request_deposit.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
            })
            .addCase(request_deposit.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Xəta baş verdi';
            })
            
            // Pay with balance
            .addCase(pay_with_balance.pending, (state) => {
                state.loader = true;
            })
            .addCase(pay_with_balance.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.balance = payload.newBalance;
                state.successMessage = payload.message;
            })
            .addCase(pay_with_balance.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Ödəniş uğursuz';
            })
            
            // Admin - get all deposits
            .addCase(get_all_deposits_admin.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_all_deposits_admin.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.deposits = payload.deposits || payload.data || [];
                state.totalDeposits = paginationTotal(payload, 'total');
            })
            .addCase(get_all_deposits_admin.rejected, (state, { payload }) => { // 👈 BU YOXDU!
                state.loader = false;
                state.errorMessage = payload?.message || 'Məlumat yüklənmədi';
            })
            
            // Admin - approve
            .addCase(approve_deposit.pending, (state) => {
                state.loader = true;
            })
            .addCase(approve_deposit.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
            })
            .addCase(approve_deposit.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Xəta baş verdi';
            })
            
            // Admin - reject
            .addCase(reject_deposit.pending, (state) => {
                state.loader = true;
            })
            .addCase(reject_deposit.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
            })
            .addCase(reject_deposit.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.message || 'Xəta baş verdi';
            })
            .addCase(get_all_sellers_balance.pending, (state) => {
                     state.loader = true;
        })
        .addCase(get_all_sellers_balance.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.sellersBalance = payload.wallets || payload.data || [];
            state.totalSellersBalance = paginationTotal(payload, 'total');
        })
        .addCase(get_all_sellers_balance.rejected, (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload?.message || 'Xəta baş verdi';
        })
        .addCase(toggle_balance_block.pending, (state) => {
    state.loader = true;
})
.addCase(toggle_balance_block.fulfilled, (state, { payload }) => {
    state.loader = false;
    state.successMessage = payload.message;
})
.addCase(toggle_balance_block.rejected, (state, { payload }) => {
    state.loader = false;
    state.errorMessage = payload?.message || 'Xəta baş verdi';
})
.addCase(get_active_bank_infos.fulfilled, (state, { payload }) => {
                state.activeBankInfos = payload.bankInfos || [];
            })
            }
        })
        

export const { messageClear } = balanceReducer.actions;
export default balanceReducer.reducer;
